import { AuthenticatedDataRequest } from '@eggplant/data-request'
import { TASK_SERVICE } from '@eggplant/api-hosts'
import type {
  Error,
  TaskPostBody,
  TaskPutBody
} from '@eggplant/types'
import type { ReactElement } from 'react'

interface Props {
  onError: (error: Error) => void
  onSuccess: () => void
  children?: () => ReactElement
  taskId: string
  params: TaskPostBody | TaskPutBody
}

const UpdateTaskRequest = ({
  onError,
  onSuccess,
  children,
  taskId,
  params
}: Props) => {
  const url = `${TASK_SERVICE}/task/${taskId}`

  return (
    <AuthenticatedDataRequest
      children={children}
      method='put'
      onError={onError}
      onSuccess={onSuccess}
      params={params}
      url={url}
    />
  )
}

export default UpdateTaskRequest
